import Table from "react-bootstrap/Table";
import styled, { css } from "styled-components";

//All page englobed
export const Page = styled.div`
	width: 100%;
	background-color: #edf4f5;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
`;

//View in css for style him in other archives
export const view = css`
	width: 100%;
	height: auto;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: var(--color-primary);
`;

//Content main is the principal secction, for example, the main content in
//dashboard is made in containers inside this. basicly is where stay the content of the page
export const ContentMain = styled.main`
	height: 100%;
	width: 100%;
	padding: 1.5rem;
	background-color: var(--color-primary);
`;

//Its a container where will stay the principal content, without contents ou blocks.
export const SubPageMain = styled.section`
	height: fit-content;
	display: flex;
	background-color: ${(props) => (props.noBg ? "" : " var(--white)")};
	flex-direction: column;
	border-radius: 0.3rem;
`;
//Section in vertical line, like Android Studio´s margin
export const VerticalMain = styled.section`
	width: 100%;
	background-color: transparent;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
`;

//Section in horizontal line, like Android Studio´s margin
export const HorizontalMain = styled.section`
	width: 100%;
	background-color: transparent;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin: 0 auto;
	padding: 8px 15px;
`;

export const Error = styled.div`
	padding: 15px 0;
	color: #d64f63;
	font-size: 1rem;
	font-weight: bold;
	text-align: center;
`;

//Screen view (Will render de components and main divs)
export const ScreenView = styled.div`
	width: 100%;
	height: auto;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: var(--color-primary);
	padding-left: 70px;
`;

//put select in order when have only one
export const SelectOrder = styled.section`
	width: 100%;
	padding: 1rem;
	margin-top: 1rem;
	display: flex;
	> div {
		width: 25%;
		padding: 0.2rem;
	}
	> input {
		min-height: 38px;
		padding: 2px 8px;
		border-color: hsl(0, 0%, 80%) !important;
		-moz-appearance: textfield;
		&::-webkit-inner-spin-button,
		&::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
		&:focus {
			box-shadow: none;
			border-color: #2684ff !important;
		}
	}
`;

//Apresentations View, contains only name, but all pages will use it
export const Apresentation = styled.section`
	padding: 1.5rem 0;
	width: 100%;
	height: fit-content;
	padding-bottom: 0.5rem;
	border-bottom: 1px ridge;
	display: flex;
	justify-content: space-between;
	background-color: var(--color-primary);
	position: sticky;
	top: 0;
	z-index: 9;

	> span {
		margin-top: 0.3rem;
		font-size: 30px;
		font-weight: 600;
	}
`;

//Create Tables for all pages (its an tab architeture style)
export const MyTable = styled(Table)`
	background-color: white;
	margin-top: 1rem;
	border-radius: 0.5rem;
	position: relative;
	/* table-layout: fixed; */

	&.sticky-header thead th {
		box-shadow: 0px 1px 0px;
		position: sticky;
		top: 57px;
		z-index: 99;
	}
	th {
		/* width: 300px; */
	}
`;

export const MyTableBody = styled.tbody`
	position: relative;
`;

export const MyTableHead = styled.thead``;

export const MyTableTR = styled.tr`
	background-color: ${(props) =>
		props.gush || props.hasError ? "#fccfd3" : ""};

	&.total-fixed td {
		position: sticky;
		bottom: 0;
		background-color: #fff;
		box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.2);
	}

	> th {
		cursor: pointer;
		text-transform: uppercase;
		font-weight: 400;
		font-size: 14px;
		color: #3d5869;
		text-align: center;
		background-color: #fff;
		transition: background-color 0.3s ease;
		:hover {
			background-color: #f2fbfd;
		}
	}

	> td {
		text-align: center;
		font-weight: 350;
		font-size: 15px;

		> button {
			margin: 0 2px;
		}
	}
`;
/*FINISH TABLE´S*/

//ALL TYPES OFF BUTTONS MADE HERE FOR PROJECT

export const DefaultButton = styled.button`
	border-radius: 4px;
	min-height: 32px;
	min-width: 32px;
	padding: 8px;
	background-color: ${(props) => (props.headerButton ? "#4a94e0" : "#6d8aa8")};
	transition: background-color 0.2s ease;
	display: flex;
	align-items: center;
	color: #fff;
	font-weight: bold;
	font-size: 16px;
	> svg {
		height: 18px;
		width: 18px;
	}
	:hover {
		background-color: ${(props) =>
			props.headerButton ? "#6aa4de" : "#87a5c4"};
	}
`;

export const ConfigBUtton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: #d9d9d9;
	transition: background-color 0.3s ease;

	> svg {
		color: black;
	}
	:hover {
		background-color: #878787;
	}
`;

export const SeeMessagesButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: var(--color-soft-green);
	transition: background-color 0.3s ease;
	> svg {
		color: white;
	}
	:hover {
		background-color: var(--color-high-green);
	}
`;

export const AttributeChatButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: var(--color-soft-blue);
	transition: background-color 0.3s ease;

	> svg {
		color: white;
	}
	:hover {
		background-color: var(--blue);
	}
`;

export const DeleteButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: var(--color-soft-red);
	transition: background-color 0.3s ease;

	> svg {
		color: white;
	}
	:hover {
		background-color: var(--color-high-red);
	}
`;

export const EditButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: #3699ff;
	transition: background-color 0.3s ease;

	> svg {
		color: white;
	}
	:hover {
		background-color: #1e83e8;
	}
`;

export const WarningButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: #ffc308;
	transition: background-color 0.3s ease;

	> svg {
		color: white;
	}
	:hover {
		background-color: #e3ab02;
	}
`;

export const TwoWaysButton = styled.button`
	padding: 0.65rem 0.9rem;
	border-radius: 0.4rem;
	background-color: ${(props) =>
		props.alert ? "#e67839" : "var(--color-soft-green)"};
	transition: background-color 0.3s ease;

	> svg {
		color: white;
	}
	:hover {
		background-color: ${(props) =>
			props.alert ? "#cc5e1f" : "var(--color-high-green)"};
	}
`;

export const PaginationContainer = styled.div`
	margin-top: 15px;
	display: flex;
	align-items: center;
	justify-content: space-around;

	> div {
		margin-left: 15px;
	}
`;
//MODAL

export const MyModalInput = styled.input`
	border-color: silver !important;
	padding: 0.4rem;
	width: 100%;
	margin-bottom: 1rem;
`;
export const MyModalBody = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 1rem;

	> h5 {
		font-weight: 350;
	}

	> label {
		color: var(--sidebar);
	}

	> div {
		margin-bottom: 1rem;
	}

	.DayPickerInput {
		width: 100%;
	}

	.DayPickerInput input {
		min-height: 38px;
		padding: 2px 8px;
		border-color: hsl(0, 0%, 80%) !important;
		max-width: 100%;
	}
	.DayPickerInput input:focus {
		border-color: #2684ff !important;
		box-shadow: none;
	}
`;
